__turbopack_context__.v({
  "articleContent": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__articleContent",
  "body": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__body",
  "description": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__description",
  "favoriteButton": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__favoriteButton",
  "image": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__image",
  "imageLink": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__imageLink",
  "primary": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__primary",
  "primaryBody": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__primaryBody",
  "primaryImage": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__primaryImage",
  "secondaryBody": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__secondaryBody",
  "secondaryImage": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__secondaryImage",
  "singleArticleMobileFullviewCard": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__singleArticleMobileFullviewCard",
  "tags": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__tags",
  "title": "SingleArticleMobileFullviewCard-module-scss-module__Z2Ji5W__title",
});
